import type { FC } from 'react'
import React, { cloneElement, useState } from 'react'
import { SortableContainer } from 'react-sortable-hoc'
import { HELPER_CLASS } from './consts'
import { FooterListItem, SortableListItem } from './SortableListItem'
import type { SortableContainerProps, SortableListComposition, SortableListProps } from './types'

const SortableListContainer = SortableContainer<SortableContainerProps>(
  ({ children, isDragged, listHasFooter, onRemove }: SortableContainerProps) => (
    <div>
      {children.map((child, index) =>
        cloneElement(child, { index, isDragged, listHasFooter, onRemove }),
      )}
    </div>
  ),
)

export const SortableList: FC<SortableListProps> & SortableListComposition = ({
  children,
  footer,
  onSortChange,
  onRemove,
}) => {
  const [isDragged, setIsDragged] = useState(false)

  const handleSortStart = () => {
    setIsDragged(true)
  }

  const handleSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
    setIsDragged(false)

    if (onSortChange) {
      onSortChange(oldIndex, newIndex)
    }
  }

  return (
    <div style={{ marginTop: 16 }}>
      <SortableListContainer
        helperClass={HELPER_CLASS}
        isDragged={isDragged}
        useDragHandle
        listHasFooter={!!footer}
        onSortStart={handleSortStart}
        onSortEnd={handleSortEnd}
        onRemove={onRemove}
      >
        {children}
      </SortableListContainer>
      {footer}
    </div>
  )
}

SortableList.FooterItem = FooterListItem
SortableList.Item = SortableListItem
